import { phoneFormat } from '../shared/util'

export const brandContent = {
    lennox: {
        clientName: 'Lennox',
        clientSite: 'www.lennoxpros.com',
        programName: 'Comfort Shield',
        programPhone: phoneFormat('866-816-2434'),
        programEmail: 'Warranty-ComfortShieldClaims@aig.com',
        advantageProgramName: 'Auto Select',
        pricingLevelName: 'Tier',
        advantageBenefits: {
            homeScreen: [
                'Lock in and protect every customer',
                'Simple, automated process',
                'Discounted pricing opportunities',
                'Manufacturer recommended strategy',
                'Closing tool for all sales',
            ],
            preferencesScreen: [
                'Lock in and protect every customer',
                'Simple, automated process',
                'Discounted pricing opportunities',
                'Manufacturer recommended strategy',
                'Closing tool for all sales',
            ],
            promoScreen: [
                'Available as standalone coverage or in conjunction with other extended service agreements',
                'All refrigerants are eligible',
                'Up to $750 reimbursement allowance for terms up to 12 years',
            ]
        }
    },
    aig: {
        clientName: '{CompanyName}',
        clientSite: '{ClientSite}',
        programName: '{ProgramName}',
        advantageProgramName: '{Advantage}',
        programPhone: phoneFormat('XXXXXXXXXX'),
        programEmail: 'XXXXXXXXXX@aig.com',
        pricingLevelName: 'Plan',
        advantageBenefits: {
            homeScreen: [
                'Zero upfront administrative work',
                'Significantly discounted pricing on shorter terms plans',
                'Reimbursement rate options',
                'Auto generated contract for every registration',
                'Profit margin opportunity on all sales',
            ],
            preferencesScreen: [
                'Zero upfront administrative work',
                'Significantly discounted pricing on shorter terms plans',
                'Reimbursement rate options',
                'Auto generated contract for every registration',
                'Profit margin opportunity on all sales',
            ]
        }
    },
    rheem: {
        clientName: 'Rheem',
        clientSite: 'MyRheem/MyRuud',
        programName: 'Protection Plus',
        advantageProgramName: 'Advanced',
        programPhone: phoneFormat('8772764294'),
        programEmail: 'Warranty-HVACClaims@aig.com',
        porProgramName: 'Express',
        pricingLevelName: 'Plan',
        valuePlanName: 'Core',
        standardPlanName: 'Premium',
        advantageBenefits: {
            homeScreen: [
                'Zero upfront administrative work',
                'Significantly discounted pricing on shorter terms plans',
                'Reimbursement rate options',
                'Auto generated contract for every registration',
                'Profit margin opportunity on all sales',
            ],
            preferencesScreen: [
                'Zero upfront administrative work',
                'Significantly discounted pricing on shorter terms plans',
                'Reimbursement rate options',
                'Auto generated contract for every registration',
                'Profit margin opportunity on all sales',
            ]
        }
    },
    carrier: {
        clientName: 'Carrier',
        clientSite: 'www.climateshieldcomplete.com',
        programName: 'Climate Shield Complete',
        advantageProgramName: 'Ease',
        programPhone: phoneFormat('8665388922'),
        programEmail: 'Warranty-HVACClaims@aig.com',
        porProgramName: 'Select',
        pricingLevelName: 'Plan',
        valuePlanName: 'Prime',
        standardPlanName: 'Standard',
        advantageBenefits: {
            homeScreen: [
                'Zero upfront administrative work',
                'Significantly discounted pricing on shorter terms plans',
                'Reimbursement rate options',
                'Auto generated contract for every registration',
                'Profit margin opportunity on all sales',
            ],
            preferencesScreen: [
                'Zero upfront administrative work',
                'Significantly discounted pricing on shorter terms plans',
                'Reimbursement rate options',
                'Auto generated contract for every registration',
                'Profit margin opportunity on all sales',
            ]
        }
    },
    trane: {
        clientName: 'Trane',
        clientSite: 'http://www.ASDealerNet.com or http://www.ComfortSite.com',
        programName: 'ComfortSure',
        advantageProgramName: '',
        specialityProgramName: 'Edge',
        advantageProgramName: 'Edge',
        programPhone: phoneFormat('8665449928'),
        programEmail: 'XXXXXXXXXXXXXXXXXX@aig.com',
        porProgramName: '',
        pricingLevelName: 'Plan',
        valuePlanName: 'Value',
        standardPlanName: 'Premium',
        advantageBenefits: {
            homeScreen: [
                'Zero upfront administrative work',
                'Significantly discounted pricing on shorter terms plans',
                'Reimbursement rate options',
                'Auto generated contract for every registration',
                'Profit margin opportunity on all sales',
            ],
            preferencesScreen: [
                'Zero upfront administrative work',
                'Significantly discounted pricing on shorter terms plans',
                'Reimbursement rate options',
                'Auto generated contract for every registration',
                'Profit margin opportunity on all sales',
            ]
        }
    },
    ge: {
        clientName: 'GE',
        clientSite: 'https://www.comfortprotectplans.com',
        programName: 'Comfort Protect',
        advantageProgramName: '',
        specialityProgramName: '',
        programPhone: phoneFormat('800-349-4020'),
        programEmail: 'ComfortProtectClaims@aig.com',
        porProgramName: '',
        pricingLevelName: 'Plan',
        advantageBenefits: {
            homeScreen: [],
            preferencesScreen: []
        }
    },
    icp: {
        clientName: 'ICP',
        clientSite: 'www.comfortpromise.com',
        programName: 'Comfort Promise',
        advantageProgramName: 'Connect',
        specialityProgramName: '',
        programPhone: phoneFormat('8665252454'),
        programEmail: 'Warranty-HVACClaims@aig.com',
        porProgramName: 'Select',
        pricingLevelName: 'Plan',
        advantageBenefits: {
            homeScreen: [
                'Zero upfront administrative work',
                'Significantly discounted pricing on shorter terms plans',
                'Reimbursement rate options',
                'Auto generated contract for every registration',
                'Profit margin opportunity on all sales',
            ],
            preferencesScreen: [
                'Zero upfront administrative work',
                'Significantly discounted pricing on shorter terms plans',
                'Reimbursement rate options',
                'Auto generated contract for every registration',
                'Profit margin opportunity on all sales',
            ]
        }
    },
    staples: {
        clientName: 'Staples',
        clientSite: 'https://staplesprotection.serviceplanhub.com',
        programName: 'Protection & Support',
        advantageProgramName: '',
        specialityProgramName: '',
        programPhone: '',
        programEmail: '',
        porProgramName: '',
        pricingLevelName: '',
        advantageBenefits: {
            homeScreen: [
                'Mechanical and Electrical Repair, Tech Support, Accidental Damage from Handling (ADH), and Power Surge',
                'Protection for All Brands',
                'Provide service with depot (ship-in), onsite and next day solutions',
                'CompTIA A+ Certified Technicians Answering Tech Support Questions',
                'No Service Fees'
            ],
            preferencesScreen: [
                
            ]
        } 
    },
    trane: {
        clientName: 'Trane',
        clientSite: 'https://www.trane.com/index.html',
        programName: "ComfortSure",
        advantageProgramName: '',
        specialityProgramName: '',
        programPhone: phoneFormat('8665449928'),
        programEmail: '',
        porProgramName: '',
        pricingLevelName: 'Plan',
        advantageBenefits: {
            homeScreen: [],
            preferencesScreen: []
        }
    },
    nordyne: {
        clientName: 'Nordyne',
        clientSite: 'https://nordynelaborwarranty.com/',
        programName: 'Nordyne Extended Labor Program',
        advantageProgramName: '',
        specialityProgramName: '',
        programPhone: phoneFormat('866-845-4718'),
        programEmail: '',
        porProgramName: '',
        pricingLevelName: 'Plan',
        advantageBenefits: {
            homeScreen: [],
            preferencesScreen: []
        }
    },
    whatscovered: {
        lennox: {
            layout: 'slider',              
            OEM_PL_PartsTerm: "7 or 10",
            OEM_PL_LaborTerm: "3",
            ESA_PL_LaborTerm: "4 or 7",
            ESA_PL_LaborTermWritten: "four or seven",
            OEM_P_PartsTerm: "10 or 12",
            ESA_P_LaborTerm: "10 or 12",
            ESA_P_LaborTermWritten: "ten or twelve"
        },
        rheem: {
            layout: 'table',
            partFlag: 'yes',
            refrigerantFlag: 'no',
        },
        carrier: {
            layout: 'slider',              
            OEM_PL_PartsTerm: "5",
            OEM_PL_LaborTerm: "3",
            ESA_PL_LaborTerm: "2",
            ESA_PL_LaborTermWritten: "two",
            OEM_P_PartsTerm: "10",
            ESA_P_LaborTerm: "10",
            ESA_P_LaborTermWritten: "ten"
        },
        ge: {
            layout: 'table',
            partFlag: 'no',
            refrigerantFlag: 'yes',
        },
        icp: {
            layout: 'table',
            partFlag: 'no',
            refrigerantFlag: 'no',
        },
        homedepot: {
            layout: 'table',
            partFlag: 'yes',
            refrigerantFlag: 'no',
        },
        mcc: {
            layout: 'table',
            partFlag: 'yes',
            refrigerantFlag: 'no',
        },
        trane: {
            layout: 'table',
            partFlag: 'yes',
            refrigerantFlag: 'yes',
        },
        nordyne: {
            layout: 'table',
            partFlag: 'no',
            refrigerantFlag: 'yes',
        },
    },
    coveragetype: {
        lennox: {
            layout: 'table',
            plan1: ["Available On", "Basic Tier for Residential Products Only", "Tier 1, Tier 2, and Tier 3 for Residential Products Only", "Available for Select Products"],
            plan2: ["Trip/Diagnostic", "yes", "yes", "yes"],
            plan3: ["Labor Costs", "yes", "yes", "yes"],
            plan4: ["Parts Markup", "", "yes", "yes"],
            plan5: ["Miscellaneous Parts", "", "yes", "Available with Tier 1, Tier 2 and Tier 3"],
            plan6: ["Out-of-Warranty Parts", "", "", "yes"],
            plan7: ["Refrigerant", "", "Available with Tier 1, Tier 2 and Tier 3", "Available with Tier 1, Tier 2 and Tier 3"],
        },
        rheem: {
            layout: 'table',
            plan1: ["Trip/Diagnostic", "yes", ""],
            plan2: ["Labor Costs", "yes", ""],
            plan3: ["Out-of-Warranty Parts", "", "yes"],
        },
        carrier: {
            layout: 'table',
            plan1: ["Trip/Diagnostic", "yes", "yes", ""],
            plan2: ["Labor Costs", "yes", "yes", ""],
            plan3: ["Parts Allowance", "", "yes", ""],
            plan4: ["Out-of-Warranty Parts", "", "", "yes"],
            plan5: ["Refrigerant", "", "yes", ""],
        },
        ge: {
            layout: 'table',
            plan1: ["Trip/Diagnostic", "yes", "yes", "yes"],
            plan2: ["Labor Costs", "yes", "yes", "yes"],
            plan3: ["Parts Markup", "", "yes", "yes"],
            plan4: ["Out-of-Warranty Parts", "", "", "yes"],
            plan5: ["Miscellaneous Parts", "", "yes", "yes"],
            plan6: ["Refrigerant", "yes", "yes", "yes"],
        },
        icp: {
            layout: 'table',
            plan1: ["Trip/Diagnostic", "yes", "yes", ""],
            plan2: ["Labor Costs", "yes", "yes", ""],
            plan3: ["Parts Markup", "", "yes", ""],
            plan4: ["Out-of-Warranty Parts", "", "", "yes"],
            plan5: ["Refrigerant", "", "yes", ""],
        },
        mcc: {
            layout: 'table',
            plan1: ["Trip/Diagnostic", "yes", "yes", "yes", ""],
            plan2: ["Labor Costs", "yes", "yes", "yes", ""],
            plan3: ["Parts Markup", "", "yes", "yes", ""],
            plan4: ["Out-of-Warranty Parts", "", "", "yes", "yes"]
        },
        homedepot: {
            layout: 'table',
            plan1: ["Trip/Diagnostic", "yes", "yes", "yes", ""],
            plan2: ["Labor Costs", "yes", "yes", "yes", ""],
            plan3: ["Parts Markup", "", "yes", "yes", ""],
            plan4: ["Out-of-Warranty Parts", "", "", "yes", "yes"]
        },
        trane: {
            layout: 'table',
            plan1: ["Trip/Diagnostic", "yes", "yes", "yes", ""],
            plan2: ["Labor Costs", "yes", "yes", "yes", ""],
            plan3: ["Parts Allowance", "", "yes", "yes", ""],
            plan4: ["Out-of-Warranty Parts", "", "", "yes", "yes"],
            plan5: ["Refrigerant", "", "yes", "", ""],
        },
        nordyne: {
            layout: 'table',
            plan1: ["Trip/Diagnostic", "yes", "yes"],
            plan2: ["Labor Costs", "yes","yes"],
            plan3: ["Out-of-Warranty Parts", "", "yes"]
        }
    },
    homedepot: {
        clientName: 'The Home Depot',
        clientSite: 'https://www.homedepot.com/services/c/hvac-installation/c16fbb4b7?vfrom=global-header',
        programName: 'The Home Depot Extended Protection Plan',
        advantageProgramName: 'Quality Promise',
        programPhone: phoneFormat('8664138201'),
        programEmail: 'Warranty-HVACClaims@aig.com',
        porProgramName: '',
        pricingLevelName: 'Tier',
        valuePlanName: 'N/A',
        standardPlanName: 'Standard',
        standardPlanOne: 'Plan 1',
        standardPlanTwo: 'Plan 2',
        standardPlanThree: 'Plan 3',
        standardPlanFour: 'Plan 4',
        standardPlanFive: 'Plan 5',
        standardPlanSix: 'N/A',
        valuePlanOne: 'N/A',
        valuePlanTwo: 'N/A',
        valuePlanThree: 'N/A',
        valuePlanFour: 'N/A',
        advantageBenefits: {
            homeScreen: [
                'Zero upfront administrative work',
                'Significantly discounted pricing on shorter terms plans',
                'Reimbursement rate options',
                'Auto generated contract for every registration',
                'Profit margin opportunity on all sales',
            ],
            preferencesScreen: [
                'Zero upfront administrative work',
                'Significantly discounted pricing on shorter terms plans',
                'Reimbursement rate options',
                'Auto generated contract for every registration',
                'Profit margin opportunity on all sales',
            ]
        }
    },
    mcc: {
        clientName: 'MCC',
        clientSite: '',
        programName: "Mechanical Contractor's Choice",
        advantageProgramName: '',
        programPhone: phoneFormat('8665131376'),
        programEmail: 'Warranty-HVACClaims@aig.com',
        porProgramName: '',
        pricingLevelName: 'Tier',
        valuePlanName: '',
        standardPlanName: '',
        standardPlanOne: '',
        standardPlanTwo: '',
        standardPlanThree: '',
        standardPlanFour: '',
        standardPlanFive: '',
        standardPlanSix: '',
        valuePlanOne: '',
        valuePlanTwo: '',
        valuePlanThree: '',
        valuePlanFour: '',
        advantageBenefits: {
            homeScreen: [],
            preferencesScreen: []
        }
    }
}

export const WhySellContent = {
    lennox: {
        heading: "Two Simple Purchase Paths",
        para1: `${brandContent['lennox']?.clientName} ${brandContent['lennox']?.programName} provides the ability to seamlessly choose your desired manufacturer's warranty and ${brandContent['lennox']?.programName} upgraded coverage, all while registering ${brandContent['lennox']?.clientName} products.`,
        para2: `The ${brandContent['lennox']?.programName} portal is easy to access from {BrandSite} and provides a simple, user friendly way to purchase ${brandContent['lennox']?.programName} coverage options.`
    },
    rheem: {
        heading: "Order Processing Made Easy",
        para1: "Advanced applies pre-selected labor coverage automatically every time you register equipment, eliminating the administration burden of order processing.",
        para2: "Express allows you to apply coverage to individual registrations using the Protection Plus Portal.",
        para3: "The Protection Plus Portal is easy to access from MyRheem/MyRuud. It provides a simple way to submit post registration sales (new and existing installations) and manage contracts."
    },
    carrier: {
        heading: "Order Processing Made Easy",
        para1: "Ease applies pre-selected labor coverage automatically every time you register equipment, eliminating the administration burden of order processing.",
        para2: "Select allows you to apply coverage to individual registrations using the Climate Shield Complete Portal.",
        para3: "The Climate Shield Complete Portal is easy to access from www.climateshieldcomplete.com. It provides a simple way to submit post registration sales (new and existing installations) and manage contracts."
    },
    ge: {
        heading: "Promote Business Growth and Customer Satisfaction",
        para1: `${brandContent['ge']?.programName}'s extended service agreements are a great way to add revenue to your business without requiring additional equipment inventory or overhead costs. While the systems you install provides a product to your customer, including an extended service agreement builds a lifetime relationship with them.`,
        para2: "Including an extended service agreement with your original proposal helps your customer recognize it as an added benefit, rather than an added cost at the end of the sales process.",
    },
    icp: {
        heading: "Order Processing Made Easy",
        para1: `${brandContent['icp']?.advantageProgramName} applies pre-selected labor coverage automatically every time you register equipment, eliminating the administration burden of order processing.`,
        para2: `${brandContent['icp']?.porProgramName} allows you to apply coverage to individual registrations using ${brandContent['icp']?.programName} Portal.`,
        para3: `The ${brandContent['icp']?.programName} Portal is easy to access from ${brandContent['icp']?.clientName} product registration site. It provides a simple way to submit post registration sales (new and existing installations) and manage contracts.`
    },
    homedepot: {
        heading: "Order Processing Made Easy",
        para1: `${brandContent['homedepot']?.advantageProgramName} eliminates upfront data entry of sales. The extended service agreements (ESAs) will be created through an automated process based on the coverage term and reimbursement plan options you select when enrolling in the ${brandContent['homedepot']?.advantageProgramName} program.`,
        para2: `Select allows you to apply coverage to individual installations using ${brandContent['homedepot']?.programName} Portal.`
    },
    
    mcc: {
        heading: "Promote Business Growth and Customer Satisfaction",
        para1: `${brandContent['mcc']?.programName}'s extended service agreements are a great way to add revenue to your business without requiring additional equipment inventory or overhead costs. While the system you install provides a product to your customer, including an extended service agreement builds a lifetime relationship with them.`,
        para2: "Including an extended service agreement with your original proposal helps your customer recognize it as an added benefit, rather than an added cost at the end of the sales process."
    },
    trane: {
        heading: "Promote Business Growth and Customer Satisfaction",
        para1: `${brandContent['trane']?.programName}’s extended service agreements are a great way to add revenue to your business without requiring additional equipment inventory or overhead costs. While the systems you install provides a product to your customer, including an extended service agreement builds a lifetime relationship with them.`,
        para2: "Including an extended service agreement with your original proposal helps your customer recognize it as an added benefit, rather than an added cost at the end of the sales process."
    },
    nordyne: {
        heading: "Promote Business Growth and Customer Satisfaction",
        para1: `${brandContent['nordyne']?.programName}’s extended service agreements are a great way to add revenue to your business without requiring additional equipment inventory or overhead costs. While the systems you install provides a product to your customer, including an extended service agreement builds a lifetime relationship with them.`,
        para2: "Including an extended service agreement with your original proposal helps your customer recognize it as an added benefit, rather than an added cost at the end of the sales process."
    }
}

export const getBrandContent = (account) => {
    const accountLower = account.toLowerCase().replace(/ /g,'');

    if (account && brandContent[accountLower]) {
        return brandContent[accountLower];
    }

    return brandContent.aig;
}

